import React from 'react'
import { Link } from 'react-router-dom'
import SEOHead from '@/components/SEO/SEOHead'
import PageHeader from '@/components/Common/PageHeader'

/**
 * SPA olduğu için sunucu gerçek 404 durum kodu döndüremez.
 * Bu yüzden sayfanın indekslenmemesi noindex ile garanti altına alınır.
 */
const NotFoundPage: React.FC = () => (
  <>
    <SEOHead
      title="Sayfa Bulunamadı | Ardıç Veteriner Kliniği"
      description="Aradığınız sayfa bulunamadı."
      noIndex
    />
    <PageHeader
      title="404 - Sayfa Bulunamadı"
      subtitle="Aradığınız sayfa taşınmış veya kaldırılmış olabilir."
    />
    <section className="section-padding">
      <div className="container-custom text-center">
        <p className="text-gray-600 mb-8">
          Aşağıdaki bağlantılardan devam edebilir veya bize ulaşabilirsiniz.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-primary">Ana Sayfa</Link>
          <Link to="/hizmetler" className="btn-secondary">Hizmetlerimiz</Link>
          <Link to="/hastaliklari" className="btn-secondary">Hastalık Rehberi</Link>
          <Link to="/contact" className="btn-secondary">İletişim</Link>
        </div>
      </div>
    </section>
  </>
)

export default NotFoundPage
